/**
 * Stable React keys for lists without ids (log lines, outbox rows): each item's own text, plus a
 * counter for repeats, so a key follows its item instead of its position.
 */
export function stableKeys<T>(items: T[], text: (item: T) => string): string[] {
  const seen = new Map<string, number>();
  return items.map((it) => {
    const k = text(it);
    const n = (seen.get(k) ?? 0) + 1;
    seen.set(k, n);
    return n > 1 ? `${k}#${n}` : k;
  });
}
